import { atom } from "jotai";

export const selectedMenuAtom = atom(null);

export const sidebarAtom = atom(false);
